@if ((corporateTaxEntity$ | async) && (vpbBerekening$ | async)) {
  <form [formGroup]="balansEnResultatenRekeningFg" style="max-width: 90%">

    <div style="min-width: 308px;"></div>
    <div class="row mb-1">
      <div class="col"></div>
      <div class="col-2">
        <p><b>{{ labelBalansSlot }}</b></p>
      </div>
      <div class="col-3">
        <p><b>{{ labelBalansOpening }}</b></p>
      </div>
    </div>

    <div class="row mb-0.5">
      <div class="col col-1" style="min-width: 308px">
        <p>Gestort en opgevraagd kapitaal</p>
      </div>
      <div class="col-2" formArrayName="gestortEnOpgevraagdKapitaal">
        @for (item of getArrayControls('gestortEnOpgevraagdKapitaal'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control class="custom-input-150"
                                              [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              formControlName="slotbalans"
                                              id="gestortEnOpgevraagdKapitaal1">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
      <div class="col-3" formArrayName="gestortEnOpgevraagdKapitaal">
        @for (item of getArrayControls('gestortEnOpgevraagdKapitaal'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control class="custom-input-150"
                                              [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              formControlName="openingsbalans"
                                              id="gestortEnOpgevraagdKapitaal2">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
    </div>

    <div class="row mb-0.5">
      <div class="col col-1" style="min-width: 308px">
        <p>Informeel kapitaal</p>
      </div>
      <div class="col-2" formArrayName="informeelKapitaal">
        @for (item of getArrayControls('informeelKapitaal'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control class="custom-input-150"
                                              [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              formControlName="slotbalans"
                                              id="informeelKapitaal1">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
      <div class="col-3" formArrayName="informeelKapitaal">
        @for (item of getArrayControls('informeelKapitaal'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control class="custom-input-150"
                                              [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              formControlName="openingsbalans"
                                              id="informeelKapitaal2">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
    </div>

    <div class="row mb-0.5">
      <div class="col col-1" style="min-width: 308px">
        <p>Agioreserve</p>
      </div>
      <div class="col-2" formArrayName="agioreserve">
        @for (item of getArrayControls('agioreserve'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control class="custom-input-150"
                                              [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              formControlName="slotbalans"
                                              id="agioreserve1">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
      <div class="col-3" formArrayName="agioreserve">
        @for (item of getArrayControls('agioreserve'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control class="custom-input-150"
                                              [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              formControlName="openingsbalans"
                                              id="agioreserve2">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
    </div>

    <div class="row mb-0.5">
      <div class="col col-1" style="min-width: 308px">
        <p>Winstreserves</p>
      </div>
      <div class="col-2" formArrayName="winstreserves">
        @for (item of getArrayControls('winstreserves'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control class="custom-input-150"
                                              [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              formControlName="slotbalans"
                                              id="winstreserves1">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
      <div class="col-3" formArrayName="winstreserves">
        @for (item of getArrayControls('winstreserves'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control class="custom-input-150"
                                              [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              formControlName="openingsbalans"
                                              id="winstreserves2">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
    </div>

    <div class="row mb-0.5">
      <div class="col col-1" style="min-width: 308px">
        <p>Kostenegalisatiereserve</p>
      </div>
      <div class="col-2">
        <snelstart-venture-fiscaal-feature-spec-ker></snelstart-venture-fiscaal-feature-spec-ker>
      </div>
      <div class="col-3" formArrayName="kostenEgalisatieReserve">
        @for (item of getArrayControls('kostenEgalisatieReserve'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control class="custom-input-150"
                                              [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              formControlName="slotbalans"
                                              id="kostenEgalisatieReserve1">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
      <div class="col-4" formArrayName="kostenEgalisatieReserve">
        @for (item of getArrayControls('kostenEgalisatieReserve'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control class="custom-input-150"
                                              [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              formControlName="openingsbalans"
                                              id="kostenEgalisatieReserve2">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
    </div>

    <div class="row mb-0.5">
      <div class="col col-1" style="min-width: 308px">
        <p>Herinvesteringsreserve</p>
      </div>
      <div class="col-2">
        <snelstart-venture-fiscaal-feature-spec-hir-2></snelstart-venture-fiscaal-feature-spec-hir-2>
      </div>
      <div class="col-3" formArrayName="herinvesteringsReserve">
        @for (item of getArrayControls('herinvesteringsReserve'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control class="custom-input-150"
                                              [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              formControlName="slotbalans"
                                              id="herinvesteringsReserve1">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
      <div class="col-4" formArrayName="herinvesteringsReserve">
        @for (item of getArrayControls('herinvesteringsReserve'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control class="custom-input-150"
                                              [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              formControlName="openingsbalans"
                                              id="herinvesteringsReserve2">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
    </div>

    <div class="row mb-0.5">
      <div class="col col-1" style="min-width: 308px">
        <p>Overige fiscale reserves</p>
      </div>
      <div class="col-2" formArrayName="overigeReserves">
        @for (item of getArrayControls('overigeReserves'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control class="custom-input-150"
                                              [disabledControl]="isFE"
                                              [minValue]="0"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              formControlName="slotbalans"
                                              id="overigeReserves1">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
      <div class="col-3" formArrayName="overigeReserves">
        @for (item of getArrayControls('overigeReserves'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control class="custom-input-150"
                                              [disabledControl]="isFE"
                                              [minValue]="0"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              formControlName="openingsbalans"
                                              id="overigeReserves2">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
    </div>

    <div class="row mb-0.5 pt-3">
      <div class="col col-1" style="min-width: 308px">
        <p>Garantievoorzieningen</p>
      </div>
      <div class="col-2">
        <snelstart-venture-fiscaal-feature-spec-garantievoorziening></snelstart-venture-fiscaal-feature-spec-garantievoorziening>
      </div>
      <div class="col-3" formArrayName="garantieVoorzieningen">
        @for (item of getArrayControls('garantieVoorzieningen'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control class="custom-input-150"
                                              [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              formControlName="slotbalans"
                                              id="garantieVoorzieningen1">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
      <div class="col-4" formArrayName="garantieVoorzieningen">
        @for (item of getArrayControls('garantieVoorzieningen'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control class="custom-input-150"
                                              [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              formControlName="openingsbalans"
                                              id="garantieVoorzieningen2">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
    </div>

    <div class="row mb-0.5">
      <div class="col col-1" style="min-width: 308px">
        <p>Oudedagsvoorzieningen</p>
      </div>
      <div class="col-2" formArrayName="oudedagsVoorzieningen">
        @for (item of getArrayControls('oudedagsVoorzieningen'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control class="custom-input-150"
                                              [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              formControlName="slotbalans"
                                              id="oudedagsVoorzieningen1">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
      <div class="col-3" formArrayName="oudedagsVoorzieningen">
        @for (item of getArrayControls('oudedagsVoorzieningen'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control class="custom-input-150"
                                              [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              formControlName="openingsbalans"
                                              id="oudedagsVoorzieningen2">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
    </div>

    <div class="row mb-0.5">
      <div class="col col-1" style="min-width: 308px">
        <p>Overige voorzieningen</p>
      </div>
      <div class="col-2">
        <snelstart-venture-fiscaal-feature-spec-overige-voorziening></snelstart-venture-fiscaal-feature-spec-overige-voorziening>
      </div>
      <div class="col-2" formArrayName="overigeVoorzieningen">
        @for (item of getArrayControls('overigeVoorzieningen'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control class="custom-input-150"
                                              [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              formControlName="slotbalans"
                                              id="overigeVoorzieningen1">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
      <div class="col-3" formArrayName="overigeVoorzieningen">
        @for (item of getArrayControls('overigeVoorzieningen'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control class="custom-input-150"
                                              [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              formControlName="openingsbalans"
                                              id="overigeVoorzieningen2">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
    </div>

    <div class="row mb-0.5 pt-3">
      <div class="col col-1" style="min-width: 308px">
        <p>Pensioenverplichtingen</p>
      </div>
      <div class="col-2" formArrayName="pensioenVoorzieningen">
        @for (item of getArrayControls('pensioenVoorzieningen'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control class="custom-input-150"
                                              [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              formControlName="slotbalans"
                                              id="pensioenVoorzieningen1">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
      <div class="col-3" formArrayName="pensioenVoorzieningen">
        @for (item of getArrayControls('pensioenVoorzieningen'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control class="custom-input-150"
                                              [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              formControlName="openingsbalans"
                                              id="pensioenVoorzieningen2">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
    </div>

    <div class="row mb-0.5">
      <div class="col col-1" style="min-width: 308px">
        <p>Langlopende schulden groepsmaatschappijen</p>
      </div>
      <div class="col-2" formArrayName="schuldenLanglopendGroepsmaatschappijen">
        @for (item of getArrayControls('schuldenLanglopendGroepsmaatschappijen'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control class="custom-input-150"
                                              [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              formControlName="slotbalans"
                                              id="schuldenLanglopendGroepsmaatschappijen1">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
      <div class="col-3" formArrayName="schuldenLanglopendGroepsmaatschappijen">
        @for (item of getArrayControls('schuldenLanglopendGroepsmaatschappijen'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control class="custom-input-150"
                                              [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              formControlName="openingsbalans"
                                              id="schuldenLanglopendGroepsmaatschappijen2">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
    </div>

    <div class="row mb-0.5">
      <div class="col col-1" style="min-width: 308px">
        <p>Langlopende schulden participanten/aandeelhouders</p>
      </div>
      <div class="col-2" formArrayName="schuldenLanglopendParticipanten">
        @for (item of getArrayControls('schuldenLanglopendParticipanten'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control class="custom-input-150"
                                              [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              formControlName="slotbalans"
                                              id="schuldenLanglopendParticipanten1">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
      <div class="col-3" formArrayName="schuldenLanglopendParticipanten">
        @for (item of getArrayControls('schuldenLanglopendParticipanten'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control class="custom-input-150"
                                              [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              formControlName="openingsbalans"
                                              id="schuldenLanglopendParticipanten2">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
    </div>

    <div class="row mb-0.5">
      <div class="col col-1" style="min-width: 308px">
        <p>Langlopende schulden kredietinstellingen</p>
      </div>
      <div class="col-2" formArrayName="schuldenLanglopendKredietinstellingen">
        @for (item of getArrayControls('schuldenLanglopendKredietinstellingen'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control class="custom-input-150"
                                              [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              formControlName="slotbalans"
                                              id="schuldenLanglopendKredietinstellingen1">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
      <div class="col-3" formArrayName="schuldenLanglopendKredietinstellingen">
        @for (item of getArrayControls('schuldenLanglopendKredietinstellingen'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control class="custom-input-150"
                                              [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              formControlName="openingsbalans"
                                              id="schuldenLanglopendKredietinstellingen2">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
    </div>

    <div class="row mb-0.5">
      <div class="col col-1" style="min-width: 308px">
        <p>Overige langlopende schulden</p>
      </div>
      <div class="col-2" formArrayName="schuldenLanglopendOverig">
        @for (item of getArrayControls('schuldenLanglopendOverig'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control class="custom-input-150"
                                              [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              formControlName="slotbalans"
                                              id="schuldenLanglopendOverig1">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
      <div class="col-3" formArrayName="schuldenLanglopendOverig">
        @for (item of getArrayControls('schuldenLanglopendOverig'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control class="custom-input-150"
                                              [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              formControlName="openingsbalans"
                                              id="schuldenLanglopendOverig2">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
    </div>

    <div class="row mb-0.5 pt-3">
      <div class="col col-1" style="min-width: 308px">
        <p>Crediteuren</p>
      </div>
      <div class="col-2" formArrayName="crediteuren">
        @for (item of getArrayControls('crediteuren'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control class="custom-input-150"
                                              [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              formControlName="slotbalans"
                                              id="crediteuren1">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
      <div class="col-3" formArrayName="crediteuren">
        @for (item of getArrayControls('crediteuren'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control class="custom-input-150"
                                              [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              formControlName="openingsbalans"
                                              id="crediteuren2">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
    </div>

    <div class="row mb-0.5">
      <div class="col col-1" style="min-width: 308px">
        <p>Omzetbelasting</p>
      </div>
      <div class="col-2">
        <snelstart-venture-fiscaal-feature-spec-omzetbelasting-passief></snelstart-venture-fiscaal-feature-spec-omzetbelasting-passief>
      </div>
      <div class="col-2" formArrayName="schuldenOmzetbelasting">
        @for (item of getArrayControls('schuldenOmzetbelasting'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control class="custom-input-150"
                                              [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              formControlName="slotbalans"
                                              id="schuldenOmzetbelasting">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
      <div class="col-3" formArrayName="schuldenOmzetbelasting">
        @for (item of getArrayControls('schuldenOmzetbelasting'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control class="custom-input-150"
                                              [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              formControlName="openingsbalans"
                                              id="schuldenOmzetbelasting2">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
    </div>

    <div class="row mb-0.5">
      <div class="col col-1" style="min-width: 308px">
        <p>Loonheffingen</p>
      </div>
      <div class="col-2" formArrayName="schuldenLoonheffingen">
        @for (item of getArrayControls('schuldenLoonheffingen'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control class="custom-input-150"
                                              [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              formControlName="slotbalans"
                                              id="schuldenLoonheffingen1">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
      <div class="col-3" formArrayName="schuldenLoonheffingen">
        @for (item of getArrayControls('schuldenLoonheffingen'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control class="custom-input-150"
                                              [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              formControlName="openingsbalans"
                                              id="schuldenLoonheffingen2">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
    </div>

    <div class="row mb-0.5">
      <div class="col col-1" style="min-width: 308px">
        <p>Kortlopende schulden groepsmaatschappijen</p>
      </div>
      <div class="col-2" formArrayName="schuldenKortlopendGroepsmaatschappijen">
        @for (item of getArrayControls('schuldenKortlopendGroepsmaatschappijen'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control class="custom-input-150"
                                              [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              formControlName="slotbalans"
                                              id="schuldenKortlopendGroepsmaatschappijen1">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
      <div class="col-3" formArrayName="schuldenKortlopendGroepsmaatschappijen">
        @for (item of getArrayControls('schuldenKortlopendGroepsmaatschappijen'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control class="custom-input-150"
                                              [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              formControlName="openingsbalans"
                                              id="schuldenKortlopendGroepsmaatschappijen2">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
    </div>

    <div class="row mb-0.5">
      <div class="col col-1" style="min-width: 308px">
        <p>Kortlopende schulden participanten/aandeelhouders</p>
      </div>
      <div class="col-2" formArrayName="schuldenKortlopendParticipanten">
        @for (item of getArrayControls('schuldenKortlopendParticipanten'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control class="custom-input-150"
                                              [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              formControlName="slotbalans"
                                              id="schuldenKortlopendParticipanten1">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
      <div class="col-3" formArrayName="schuldenKortlopendParticipanten">
        @for (item of getArrayControls('schuldenKortlopendParticipanten'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control class="custom-input-150"
                                              [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              formControlName="openingsbalans"
                                              id="schuldenKortlopendParticipanten2">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
    </div>

    <div class="row mb-0.5">
      <div class="col col-1" style="min-width: 308px">
        <p>Overige kortlopende schulden</p>
      </div>
      <div class="col-2" formArrayName="schuldenKortlopendOverig">
        @for (item of getArrayControls('schuldenKortlopendOverig'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control class="custom-input-150"
                                              [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              formControlName="slotbalans"
                                              id="schuldenKortlopendOverig1">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
      <div class="col-3" formArrayName="schuldenKortlopendOverig">
        @for (item of getArrayControls('schuldenKortlopendOverig'); track item; let j = $index) {
          <div [formGroupName]="j">
            <snelstart-ui-number-form-control class="custom-input-150"
                                              [disabledControl]="isFE"
                                              [prefix]="'€'"
                                              [showAllDecimals]="false"
                                              align="right"
                                              formControlName="openingsbalans"
                                              id="schuldenKortlopendOverig2">
            </snelstart-ui-number-form-control>
          </div>
        }
      </div>
    </div>
  </form>
}

<form [formGroup]="berekendePassivaFg" style="max-width: 90%">
  <div class="row mb-0.5 pt-3">
    <div class="col col-1" style="min-width: 308px">
      <p><b>Totaal passiva</b></p>
    </div>
    <div class="col-2">
      <snelstart-ui-number-form-control [prefix]="'€'"
                                        [showAllDecimals]="false"
                                        align="right"
                                        class="custom-input-150 custom-readonly"
                                        formControlName="totaalPassivaEind"
                                        id="totaal1">
      </snelstart-ui-number-form-control>
    </div>
    <div class="col-3">
      <snelstart-ui-number-form-control [prefix]="'€'"
                                        [showAllDecimals]="false"
                                        align="right"
                                        class="custom-input-150 custom-readonly"
                                        formControlName="totaalPassivaBegin"
                                        id="totaal2">
      </snelstart-ui-number-form-control>
    </div>
  </div>
</form>
